// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB5lV85VN0iKurx-dKSYi2LbpdQVT9YIeY",
    authDomain: "clientpanelprod-f9069.firebaseapp.com",
    databaseURL: "https://clientpanelprod-f9069.firebaseio.com",
    projectId: "clientpanelprod-f9069",
    storageBucket: "clientpanelprod-f9069.appspot.com",
    messagingSenderId: "307065123538"
  }  
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
